<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="refresh-loco-status">
  <div class="loco-status-page-label">
    <strong>{{configData && configData.queryViewLabel.queryView}}</strong>
  </div>
  <button id="defaultSearchButton" type="button" (click)="refreshLocoStatus()">
              <i class='fa fa-refresh'></i></button>
  <div class="last-refresh">
    <p>{{configData && configData.queryViewLabel.lastRefresh}}</p>
    <span><strong>{{lastRefreshTime ? lastRefreshTime : 'N/A'}}</strong></span>
  </div>
  <lms-tabs [tabs]="tabs" [editMode]="editMode?.status" (lmsTabChange)="lmsEventHandler($event)"></lms-tabs>
</div>